import {
	type ProjectType,
	CORE_PROJECT,
	PRODUCT_DISCOVERY_PROJECT,
	SOFTWARE_PROJECT,
	SERVICE_DESK_PROJECT,
} from '@jira/platform__project-types/src/project-types.tsx';

import { useEnvironment } from '@atlassian/jira-tenant-context-controller/src/components/environment/index.tsx';
import {
	DEFER_EDITION_XFLOW_TO_JPD_MSG_ID,
	DEFER_EDITION_XFLOW_TO_JPD_MSG_ID_STG,
	DEFER_EDITION_XFLOW_TO_JSM_MSG_ID,
	DEFER_EDITION_XFLOW_TO_JSM_MSG_ID_STG,
	DEFER_EDITION_XFLOW_TO_JSW_MSG_ID,
	DEFER_EDITION_XFLOW_TO_JSW_MSG_ID_STG,
	DEFER_EDITION_XFLOW_TO_JWM_MSG_ID,
	DEFER_EDITION_XFLOW_TO_JWM_MSG_ID_STG,
} from '../../constants.tsx';

export const useDeferEpMessageKey = (projectType: ProjectType | undefined) => {
	const environment = useEnvironment();
	const isProdEnv = environment === 'prod';

	switch (projectType) {
		case CORE_PROJECT:
			return isProdEnv ? DEFER_EDITION_XFLOW_TO_JWM_MSG_ID : DEFER_EDITION_XFLOW_TO_JWM_MSG_ID_STG;
		case SOFTWARE_PROJECT:
			return isProdEnv ? DEFER_EDITION_XFLOW_TO_JSW_MSG_ID : DEFER_EDITION_XFLOW_TO_JSW_MSG_ID_STG;
		case PRODUCT_DISCOVERY_PROJECT:
			return isProdEnv ? DEFER_EDITION_XFLOW_TO_JPD_MSG_ID : DEFER_EDITION_XFLOW_TO_JPD_MSG_ID_STG;
		case SERVICE_DESK_PROJECT:
			return isProdEnv ? DEFER_EDITION_XFLOW_TO_JSM_MSG_ID : DEFER_EDITION_XFLOW_TO_JSM_MSG_ID_STG;
		default:
			return undefined;
	}
};

const getDismissSessionStorageKey = (accountId: string | null, messageId: string | undefined) =>
	`po:ep-external-proxy:dismissed:${accountId}:${messageId}`;

const dismissedStorage = new Set<string>();

export const dismissMessageInSession = (
	accountId: string | null,
	messageId: string | undefined,
) => {
	const dismissKey = getDismissSessionStorageKey(accountId, messageId);
	dismissedStorage.add(dismissKey);
};

export const isMessageDismissedInSession = (
	accountId: string | null,
	messageId: string | undefined,
) => {
	const dismissKey = getDismissSessionStorageKey(accountId, messageId);
	return !!dismissedStorage.has(dismissKey);
};

export const __resetDismissedStorage = () => dismissedStorage.clear();
